(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-option-b-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-option-b-slider')) {
    customElements.define('product-card-option-b-slider', class extends HTMLElement {
      connectedCallback() {
        this.syncSlider = () => {
          if (!this.isConnected) return;

          if (!this.getClientRects().length || !this.offsetWidth) {
            this.swiper?.destroy(true, true);
            this.swiper = null;
            return;
          }

          if (this.swiper || typeof window.Swiper !== 'function') return;

          const container = this.querySelector('.swiper');
          if (!container) return;

          this.swiper = new window.Swiper(container, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true,
            spaceBetween: 0,
            watchOverflow: true,
            preventClicks: true,
            preventClicksPropagation: true,
            pagination: {
              el: this.querySelector('.swiper-pagination'),
              clickable: true,
              bulletElement: 'button'
            },
            a11y: {
              paginationBulletMessage: this.dataset.paginationLabel.replace('[index]', '{{index}}'),
              slideLabelMessage: this.dataset.slideLabel.replace('[index]', '{{index}}').replace('[count]', '{{slidesLength}}')
            }
          });
        };

        this.resizeObserver = new ResizeObserver(this.syncSlider);
        this.resizeObserver.observe(this);
        window.addEventListener('load', this.syncSlider);
        this.syncSlider();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.removeEventListener('load', this.syncSlider);
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
